var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElevator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 24 24",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3B3B58",
    d: "M7.885 17.5h2v-3.808h1V9.615h-4v4.077h1V17.5Zm1.002-8.808q.446 0 .75-.307q.305-.308.305-.753t-.307-.75q-.308-.305-.753-.305t-.75.307q-.305.308-.305.753q0 .446.307.75q.308.305.753.305Zm4.825 1.808h3.192l-1.596-2.558l-1.596 2.558Zm1.596 5.558l1.596-2.558h-3.192l1.596 2.558ZM4 20V4h16v16H4Zm1-1h14V5H5v14Zm0 0V5v14Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElevator);
export default __webpack_public_path__ + "static/media/elevator.c0276e77c5efc3df9e7e0509fb408047.svg";
export { ForwardRef as ReactComponent };